import { ComponentProps } from 'react';
import {
  PromptInput,
  PromptInputBody,
  PromptInputTextarea,
  PromptInputSubmit,
} from './prompt-input';

/**
 * Opinionated single-line layout over the PromptInput primitives.
 * Wraps composition to enforce consistent structure across usages
 */
type PromptInputSimpleProps = {
  /** Called on submit (Enter or button) */
  onSubmit: ComponentProps<typeof PromptInput>['onSubmit'];
  placeholder: ComponentProps<typeof PromptInputTextarea>['placeholder'];
  /** Number of min lines to show. Default is 2. */
  minLines?: ComponentProps<typeof PromptInputTextarea>['minLines'];
  textAreaProps?: ComponentProps<typeof PromptInputTextarea>;
  submitButtonProps?: ComponentProps<typeof PromptInputSubmit>;
};

export const PromptInputSimple = ({
  onSubmit,
  placeholder = 'Type your message...',
  minLines = 2,
  textAreaProps,
  submitButtonProps,
}: PromptInputSimpleProps) => (
  <PromptInput onSubmit={onSubmit}>
    <PromptInputBody className="flex w-full items-end">
      <PromptInputTextarea
        placeholder={placeholder}
        // Extra right padding reserves space for the absolutely-positioned submit button.
        className="pr-[60px]"
        minLines={minLines}
        {...textAreaProps}
      />
      <div className="absolute right-0 bottom-0 py-[10px] pr-4">
        <PromptInputSubmit {...submitButtonProps} />
      </div>
    </PromptInputBody>
  </PromptInput>
);
